// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cog-stripe-card-placeholder{margin-bottom:calc(var(--gutter)/4)}.cog-stripe-card-placeholder__payment-type .cog-field__placeholder-inner{min-height:55px}", ""]);
// Exports
module.exports = exports;
